import { isAuthError } from './helpers';
import { useGlobalApiErrors } from './hooks';

export const errorService = {
    isAuthError,
    useGlobalApiErrors,
};
